import { z } from "zod";

export const APPRAISAL_SCHEDULE_FILTERS = ["all", "missing", "overdue"] as const;
export type AppraisalScheduleFilter = (typeof APPRAISAL_SCHEDULE_FILTERS)[number];

export const appraisalSchedulesSearchSchema = z
  .object({
    filter: z.enum(APPRAISAL_SCHEDULE_FILTERS).catch("all").default("all"),
  })
  .strict();
export type AppraisalSchedulesSearch = z.infer<typeof appraisalSchedulesSearchSchema>;
